import { render, staticRenderFns } from "./DressSearchForm.vue?vue&type=template&id=62fd22f3&scoped=true"
import script from "./DressSearchForm.vue?vue&type=script&lang=js"
export * from "./DressSearchForm.vue?vue&type=script&lang=js"
import style0 from "./DressSearchForm.vue?vue&type=style&index=0&id=62fd22f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fd22f3",
  null
  
)

export default component.exports